import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { SvgIconProps } from 'ha/ui/SvgIcon';
import { Grid, Typography } from '@hbf/dsl';

const useStyles = makeStyles()(theme => ({
  container: {
    width: '100%',
    height: '100%',
    backgroundColor: theme.palette.grey[50],
    margin: 0,
  },
  item: {
    padding: '6px',
    [theme.breakpoints.up('sm')]: {
      padding: '8px',
    },
  },
  iconRoot: {
    fontSize: '51px',
    color: theme.palette.grey[150],
    [theme.breakpoints.up('sm')]: {
      fontSize: '75px',
    },
  },
  text: {
    color: theme.palette.grey[300],
  },
  fixedHeight: {
    boxSizing: 'content-box',
    height: '51px',
    [theme.breakpoints.up('sm')]: {
      height: '75px',
    },
  },
}));

interface Props {
  IconComponent: React.ComponentType<SvgIconProps>;
  text: string;
}

export const PhotoPlaceholder: React.FC<Props> = ({ IconComponent, text }) => {
  const { classes, cx } = useStyles();

  return (
    <Grid
      container
      alignContent="center"
      alignItems="center"
      justifyContent="center"
      className={classes.container}
      direction="column"
    >
      <Grid item className={cx(classes.item, classes.fixedHeight)}>
        <IconComponent className={classes.iconRoot} />
      </Grid>
      <Grid item className={classes.item}>
        <Typography.Paragraph className={classes.text}>
          {text}
        </Typography.Paragraph>
      </Grid>
    </Grid>
  );
};
